/**
 * useChangePassword - Hook for handling password change.
 *
 * Provides a mutation hook for changing the authenticated user's password.
 */

import { useMutation } from '@tanstack/react-query';
import { changePassword } from '@/lib/api';

interface ChangePasswordParams {
  currentPassword: string;
  newPassword: string;
}

/**
 * Hook for handling password change mutation.
 *
 * @returns Mutation object with:
 * - `mutateAsync`: Async function to trigger password change
 * - `isPending`: Boolean indicating if the request is in progress
 * - `error`: Error object if the request failed
 * - `isSuccess`: Boolean indicating if the password was changed
 * - `reset`: Function to reset the mutation state
 */
export function useChangePassword() {
  return useMutation({
    mutationFn: ({ currentPassword, newPassword }: ChangePasswordParams) =>
      changePassword(currentPassword, newPassword),
  });
}
